export class AutoReload {

    private timerid

    constructor(reloadAuto: HTMLInputElement) {
        if (localStorage.getItem('reload') == 'on') {
            reloadAuto.setAttribute('checked', '');
            this.timerid = this.setTimer();
        }
        this.toggleListener(reloadAuto);
    }

    toggleListener(reloadAuto: HTMLInputElement) {
        reloadAuto.addEventListener('change', () => {
            if (this.checkIfToggleIsOn(reloadAuto)) {
                this.setNewsAutoReloadInLocalStorage();
                this.timerid = this.setTimer();
            } else {
                this.removeNewsAutoReloadInLocalStorage();
                clearTimeout(this.timerid);
            }
        });
    }

    setTimer() {
        const timerId: ReturnType<typeof setTimeout> = setTimeout(() => {
            location.reload();
        }, 5 * 60 * 1000); // Minuten * Sekunden * Millisekunden
        return timerId;
    }

    checkIfToggleIsOn(reloadAuto: HTMLInputElement):boolean {
        return reloadAuto.checked;
    }

    setNewsAutoReloadInLocalStorage() {
        localStorage.setItem('reload', 'on');
    }

    removeNewsAutoReloadInLocalStorage() {
        localStorage.removeItem('reload');
    }
}
